import { render, staticRenderFns } from "./ClubMenu.vue?vue&type=template&id=b84c9f46&scoped=true"
import script from "./ClubMenu.vue?vue&type=script&lang=js"
export * from "./ClubMenu.vue?vue&type=script&lang=js"
import style0 from "./ClubMenu.vue?vue&type=style&index=0&id=b84c9f46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84c9f46",
  null
  
)

export default component.exports